import { useEffect } from 'react';
import { useLocalAccountsTargetUserGroups } from '@Policy/hooks';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { TreeNode } from '@Components/Tree/type';
import { RoleTarget } from '@Types/administrator';

export const LocalAccountTargets = ({
  setCheckTargets,
}: {
  setCheckTargets: (checkedKeys: RoleTarget[]) => void;
}) => {
  const props = useLocalAccountsTargetUserGroups();

  useEffect(() => {
    const targets: RoleTarget[] = props.policyTarget.map((item: TreeNode) => ({
      displayName: String(item.title),
      target: String(item.key),
    }));
    setCheckTargets(targets);
    console.log('policyTargetRef.current', targets);
  }, [props.policyTarget]);
  return <TargetUserGroups {...props} />;
};
